export const fieldTeamStyles = `
.ftl-root { font-family: 'Inter', -apple-system, BlinkMacSystemFont, sans-serif; }
.ftl-scroll-target { scroll-margin-top: 88px; }
.ftl-hero-devices { position: relative; width: 100%; max-width: 620px; margin: 0 auto; min-height: 280px; }
.ftl-laptop { width: 100%; filter: drop-shadow(0 24px 48px rgba(15,23,42,0.14)); }
.ftl-laptop-lid {
  background: linear-gradient(180deg, #1e293b, #0f172a);
  border-radius: 14px 14px 8px 8px;
  padding: 12px 12px 10px;
  box-shadow: inset 0 1px 0 rgba(255,255,255,0.08);
}
.ftl-laptop-camera { width: 6px; height: 6px; border-radius: 50%; background: #334155; margin: 0 auto 8px; }
.ftl-laptop-screen {
  border-radius: 6px;
  overflow: hidden;
  background: #F8FAFC;
  aspect-ratio: 16 / 10;
  line-height: 0;
}
.ftl-laptop-screen img {
  width: 100%;
  height: 100%;
  object-fit: contain;
  object-position: top center;
  display: block;
  background: #F8FAFC;
}
.ftl-laptop-base {
  height: 12px;
  width: 108%;
  margin: 0 auto 0 -4%;
  background: linear-gradient(180deg, #E2E8F0, #94A3B8);
  border-radius: 0 0 12px 12px;
  box-shadow: 0 8px 16px rgba(15,23,42,0.08);
}
.ftl-laptop-notch {
  width: 72px;
  height: 6px;
  margin: -6px auto 0;
  background: #CBD5E1;
  border-radius: 0 0 8px 8px;
}
.ftl-hero-phone {
  position: absolute;
  right: -4%;
  bottom: -8%;
  width: min(38%, 168px);
  z-index: 2;
  filter: drop-shadow(0 18px 32px rgba(15,23,42,0.18));
}
.ftl-hero-phone .dcl-preview-phone { max-width: 100% !important; }
.ftl-device-stage { position: relative; display: flex; flex-direction: column; align-items: center; gap: 28px; }
.ftl-device-stage-laptop { width: 100%; max-width: 720px; }
.ftl-device-phones { display: flex; justify-content: center; gap: 16px; flex-wrap: wrap; }
.ftl-solution-grid { display: grid; grid-template-columns: 1fr; gap: 16px; }
.ftl-solution-card {
  display: flex;
  flex-direction: column;
  text-decoration: none;
  color: inherit;
  position: relative;
  overflow: hidden;
  background: linear-gradient(135deg, rgba(248,250,252,0.95), #FFF);
  border-radius: 20px;
  border: 1px solid rgba(226,232,240,0.9);
  box-shadow: 0 1px 2px rgba(15,23,42,0.04), 0 12px 40px -12px rgba(15,23,42,0.08);
  transition: transform 0.35s, box-shadow 0.35s, border-color 0.35s;
}
.ftl-solution-card:hover { transform: translateY(-4px); box-shadow: 0 20px 50px -20px rgba(15,23,42,0.12); border-color: #BFDBFE; }
.ftl-solution-card-body { padding: 24px 22px 26px; display: flex; flex-direction: column; flex: 1; }
.ftl-solution-cta { margin-top: auto; padding-top: 16px; display: inline-flex; align-items: center; gap: 6px; font-size: 14px; font-weight: 700; color: #2563EB; }
.ftl-login-card {
  background: #FFF;
  border: 1px solid rgba(226,232,240,0.9);
  border-radius: 20px;
  padding: 28px 24px;
  box-shadow: 0 1px 2px rgba(15,23,42,0.04), 0 20px 50px -20px rgba(15,23,42,0.12);
}
.ftl-role-row { display: flex; flex-wrap: wrap; gap: 8px; margin-bottom: 20px; }
.ftl-role-pill {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 10px;
  border-radius: 999px;
  background: #F8FAFC;
  border: 1px solid #E2E8F0;
  font-size: 12px;
  font-weight: 600;
  color: #475569;
}
.ftl-role-dot { width: 6px; height: 6px; border-radius: 50%; }
.ftl-input-wrap { position: relative; }
.ftl-input-wrap svg { position: absolute; left: 14px; top: 50%; transform: translateY(-50%); color: #94A3B8; pointer-events: none; }
.ftl-input-wrap .dcl-input { padding-left: 42px; }
.ftl-input-wrap .ftl-eye {
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  border: none;
  background: transparent;
  color: #94A3B8;
  cursor: pointer;
  padding: 6px;
}
.ftl-store-row { display: flex; flex-wrap: wrap; gap: 8px; }
.ftl-nav-solutions { position: relative; }
.ftl-nav-solutions-menu {
  display: none;
  position: absolute;
  top: calc(100% + 10px);
  left: 50%;
  transform: translateX(-50%);
  min-width: 240px;
  background: #FFF;
  border: 1px solid #E2E8F0;
  border-radius: 16px;
  padding: 8px;
  box-shadow: 0 16px 40px rgba(15,23,42,0.12);
  z-index: 60;
}
.ftl-nav-solutions:hover .ftl-nav-solutions-menu,
.ftl-nav-solutions:focus-within .ftl-nav-solutions-menu { display: block; }
.ftl-nav-solutions-menu a {
  display: block;
  padding: 10px 12px;
  border-radius: 10px;
  color: #334155;
  text-decoration: none;
  font-size: 14px;
  font-weight: 600;
}
.ftl-nav-solutions-menu a:hover { background: #F8FAFC; color: #2563EB; }
.ftl-sol-hero-copy { max-width: 560px; }
.ftl-feature-list { list-style: none; margin: 0; padding: 0; display: flex; flex-direction: column; gap: 12px; }
.ftl-feature-list li { display: flex; align-items: flex-start; gap: 10px; font-size: 15px; line-height: 1.55; color: #475569; }
@media (min-width: 768px) {
  .ftl-solution-grid { grid-template-columns: repeat(2, 1fr); }
  .ftl-hero-phone { width: min(34%, 180px); right: -2%; bottom: -6%; }
}
@media (min-width: 1024px) {
  .ftl-solution-grid { grid-template-columns: repeat(3, minmax(0, 1fr)); }
  .ftl-device-stage { flex-direction: row; align-items: flex-end; justify-content: center; gap: 0; }
  .ftl-device-stage-laptop { margin-right: -24px; }
  .ftl-login-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 48px; align-items: center; }
}
@media (max-width: 767px) {
  .ftl-hero-phone { position: relative; right: auto; bottom: auto; width: min(180px, 56vw); margin: 16px auto 0; }
  .ftl-hero-devices { min-height: 0; }
  .ftl-nav-solutions-menu { position: static; transform: none; box-shadow: none; border: none; padding: 0 0 0 12px; display: block; }
}
@media (hover: none) and (pointer: coarse) {
  .ftl-solution-card:hover { transform: none; }
}
.ftl-market-line { margin: 0 0 8px; font-size: 15px; line-height: 1.55; color: #475569; max-width: 540px; }
.ftl-africa-line { margin: 0 0 20px; font-size: 14px; font-weight: 700; color: #2563EB; }
.ftl-africa-line--center { text-align: center; margin: 16px 0 0; }
.ftl-hero-text-links { margin-top: 16px; }
.ftl-story { display: flex; flex-direction: column; align-items: center; gap: 12px; }
.ftl-story-row { display: flex; flex-wrap: wrap; justify-content: center; gap: 10px; }
.ftl-story-chip {
  display: inline-flex; align-items: center; gap: 8px;
  padding: 10px 16px; border-radius: 999px; background: #FFF;
  border: 1px solid #E2E8F0; font-size: 14px; font-weight: 700; color: #334155;
}
.ftl-story-arrow { color: #94A3B8; font-size: 20px; line-height: 1; }
.ftl-story-node {
  padding: 14px 22px; border-radius: 16px; font-weight: 800; font-size: 15px; text-align: center;
  border: 1px solid #E2E8F0; background: #FFF;
}
.ftl-story-node--app { background: #EFF6FF; border-color: #BFDBFE; color: #1D4ED8; }
.ftl-story-node--platform { background: linear-gradient(135deg, #2563EB, #4F46E5); color: #FFF; border-color: transparent; }
.ftl-story-node--mgmt { background: #F8FAFC; }
.ftl-q-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 12px; margin-top: 28px; }
.ftl-q-card { background: #FFF; border: 1px solid #E2E8F0; border-radius: 16px; padding: 16px 18px; }
.ftl-q-card h3 { margin: 0 0 6px; font-size: 16px; font-weight: 800; color: #0F172A; }
.ftl-q-card p { margin: 0; font-size: 14px; line-height: 1.5; color: #64748B; }
.ftl-section-close { margin: 28px 0 0; text-align: center; font-size: 18px; font-weight: 800; color: #0F172A; }
.ftl-platform-grid { display: grid; grid-template-columns: 1fr; gap: 20px; }
.ftl-platform-card {
  background: #FFF; border: 1px solid #E2E8F0; border-radius: 20px; padding: 24px;
  box-shadow: 0 12px 40px -16px rgba(15,23,42,0.1);
}
.ftl-platform-visual { display: flex; justify-content: center; margin-bottom: 20px; }
.ftl-cap-grid { grid-template-columns: 1fr; }
.ftl-industry-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 12px; }
.ftl-industry-miss {
  margin-top: 32px; text-align: center; background: #F8FAFC; border: 1px solid #E2E8F0;
  border-radius: 20px; padding: 28px 20px;
}
.ftl-industry-miss h3 { margin: 0 0 8px; font-size: 22px; font-weight: 800; }
.ftl-industry-miss p { margin: 0 0 16px; color: #64748B; }
.ftl-compare { display: grid; grid-template-columns: 1fr; gap: 16px; }
.ftl-compare-card { border-radius: 20px; padding: 24px; border: 1px solid #E2E8F0; background: #FFF; }
.ftl-compare-card h3 { margin: 0 0 16px; font-size: 20px; font-weight: 800; }
.ftl-compare-card ul { margin: 0; padding: 0; list-style: none; display: flex; flex-direction: column; gap: 10px; }
.ftl-compare-card li { font-size: 15px; color: #475569; padding-left: 18px; position: relative; }
.ftl-compare-card--without li::before { content: '–'; position: absolute; left: 0; color: #94A3B8; }
.ftl-compare-card--with { border-color: #BFDBFE; background: linear-gradient(180deg, #EFF6FF, #FFF); }
.ftl-compare-card--with li::before { content: '✓'; position: absolute; left: 0; color: #2563EB; font-weight: 800; }
.ftl-steps { display: grid; grid-template-columns: 1fr; gap: 16px; }
.ftl-how-cta { display: flex; justify-content: center; margin-top: 32px; }
.ftl-geo-cities { text-align: center; font-size: 15px; line-height: 1.8; color: #475569; max-width: 720px; margin: 0 auto; }
.ftl-faq { display: flex; flex-direction: column; gap: 14px; max-width: 800px; margin: 0 auto; }
.ftl-faq-item { background: #FFF; border: 1px solid #E2E8F0; border-radius: 16px; padding: 20px 22px; }
.ftl-faq-item h3 { margin: 0 0 8px; font-size: 17px; font-weight: 800; }
.ftl-faq-item p { margin: 0; color: #64748B; line-height: 1.6; }
.ftl-final-know { list-style: none; margin: 20px 0 28px; padding: 0; display: flex; flex-direction: column; gap: 8px; }
.ftl-final-know li { color: #CBD5E1; font-weight: 600; }
.ftl-final-actions { display: flex; flex-wrap: wrap; justify-content: center; gap: 12px; }
.ftl-sticky {
  position: fixed; left: 0; right: 0; bottom: 0; z-index: 40;
  background: rgba(255,255,255,0.94); backdrop-filter: blur(12px);
  border-top: 1px solid #E2E8F0; padding: 10px 16px;
}
.ftl-sticky-spacer { height: 64px; }
.ftl-sticky-inner { max-width: 1140px; margin: 0 auto; display: flex; align-items: center; justify-content: space-between; gap: 12px; }
.ftl-sticky-copy { margin: 0; font-size: 14px; font-weight: 700; color: #334155; }
.ftl-sticky-actions { display: flex; gap: 8px; flex-shrink: 0; }
@media (min-width: 768px) {
  .ftl-q-grid { grid-template-columns: repeat(4, 1fr); }
  .ftl-cap-grid { grid-template-columns: repeat(2, 1fr); }
  .ftl-industry-grid { grid-template-columns: repeat(3, 1fr); }
  .ftl-compare { grid-template-columns: 1fr 1fr; }
  .ftl-steps { grid-template-columns: repeat(3, 1fr); }
}
@media (min-width: 1024px) {
  .ftl-platform-grid { grid-template-columns: 1fr 1fr; align-items: start; }
  .ftl-cap-grid { grid-template-columns: repeat(5, 1fr); }
  .ftl-industry-grid { grid-template-columns: repeat(4, 1fr); }
}
@media (max-width: 767px) {
  .ftl-q-grid { grid-template-columns: 1fr 1fr; }
  .ftl-industry-grid { grid-template-columns: 1fr; }
  .ftl-sticky-copy, .ftl-sticky-demo { display: none; }
  .ftl-sticky-inner { justify-content: center; }
}
`;
